import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import { useScroll, motion } from "motion/react";
import { useRef, type RefObject } from "react";
import { SectionHeader } from "./SectionHeader";
import { ExperienceAccordion } from "../ExperienceAccordion";
import { ProjectCard } from "../ProjectCard/ProjectCard";
import { projects } from "@/data/projects";
import { workExperience } from "@/data/workExperience";

export default function WorkExperienceSection({ ref }: { ref?: RefObject<HTMLDivElement | null> }) {
  const container = ref || useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({ target: container, offset: ["start start", "end end"] }); // Progress starts when the section has completely filled the viewport

  // Obtain a list of all the unique technologies from workExperience and projects
  const familiarTechnologies = Array.from(
    new Set(workExperience.flatMap((exp) => exp.techStack || []).concat(projects.flatMap((proj) => proj.techStack || []))),
  );

  return (
    <ScrollAnimContext.Provider value={scrollYProgress}>
      <div id='work' className={"text-base-content bg-base-300 w-full flex flex-col items-center rounded-4xl 2xl:rounded-[4rem]"} ref={container}>
        <div className='xl:w-4/5 2xl:w-7/10 4xl:w-3/5 py-16 2xl:py-48 px-6 lg:px-12'>
          {/* Experience Section */}
          <div>
            <SectionHeader heading='Experience' />
            <div className='flex flex-col gap-6 py-12 2xl:py-16'>
              {workExperience.map((exp, index) => (
                <ExperienceAccordion
                  key={index}
                  title={exp.title}
                  company={exp.company}
                  duration={exp.duration}
                  logo={exp.logo}
                  content={exp.content}
                  techStack={exp.techStack}
                  // open={index === 0}
                  open
                />
              ))}
            </div>
          </div>
          {/* Projects Section */}
          <div className='mt-24 lg:mt-48'>
            <SectionHeader heading="Some of the stuff I've worked on" />
            <div className='grid md:grid-cols-2 3xl:grid-cols-3 gap-12 pt-16'>
              {projects.map((project, index) => (
                <ProjectCard
                  key={index}
                  title={project.title}
                  description={project.description}
                  repoLink={project.repoLink}
                  learnMoreLink={project.learnMoreLink}
                  hackathon={project.hackathon}
                  techStack={project.techStack}
                  images={project.images}
                />
              ))}
            </div>
          </div>
        </div>
        {/* Familiar technologies section */}
        {/* <div className='bg-base-200 w-full pt-4 pb-8 drop-shadow-xl'>
          {familiarTechnologies.map((tech, index) => (
            <Badge key={index} text={tech} className='text-base ml-4 mt-4' />
          ))}
        </div> */}
      </div>
    </ScrollAnimContext.Provider>
  );
}
